import { render, staticRenderFns } from "./TextToPayKPIs.vue?vue&type=template&id=7d58ab66&"
import script from "./TextToPayKPIs.vue?vue&type=script&lang=js&"
export * from "./TextToPayKPIs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports